import {
  IPortfolioPerformanceAccounts,
  IPortfolioPerformanceAccountMetricTimeseriesData,
} from '../portfolio-performance.types';

export const METRICS = ['PV', 'DELTA', 'GAMMA', 'THETA', 'VEGA'] as const;

export type MetricKey = (typeof METRICS)[number];

/** Per-metric timeseries payload as returned by the portfolio-performance WS channel. */
export type MetricData = IPortfolioPerformanceAccountMetricTimeseriesData | null;

export interface TickPayload {
  timestamp: number;
  metrics: Record<MetricKey, number>;
}

export interface RiskContextValue {
  account: IPortfolioPerformanceAccounts;
  selectedToken: string;
  setSelectedToken: (t: string) => void;
  selectedRange: string;
  setSelectedRange: (r: string) => void;
  selectedMetrics: MetricKey[];
  setSelectedMetrics: (m: MetricKey[]) => void;
  riskTokenType: string;
  setRiskTokenType: (t: string) => void;
  metricsData: Record<MetricKey, MetricData>;
  loadingMetrics: Record<MetricKey, boolean>;
  errorMetrics: Record<MetricKey, boolean>;
  refetchAll: () => void;
  refetchMetric: (m: MetricKey) => void;
  subscribeToPerformanceTick: (fn: (t: TickPayload) => void) => () => void;
  fetchHistoricalChunk: (metric: MetricKey, toTs: number) => void;
}
